import styled from "styled-components";
import {CssRule} from "../../../themes/architecture/css-helpers/css-rule";
import {GameJackpotComponent} from "../../game-jackpot/game-jackpot.component";

export const GameDetailsJpBox = styled(GameJackpotComponent)`
    padding: 0 0 0.5rem 0;
    text-align: center;
    ${({theme}) => theme.font.presets.ultra};
    font-size: 2.4em;
    font-weight: 800;

    ${CssRule.For.mobile.build()} & {
        font-size: 1.8rem;
    }
`;